import { gql } from '@apollo/client';

export const MUTATION_CREATE_PROJECT_ANALYSIS_REPORT_DRAFT = gql`
  mutation CreateProjectAnalysisReportDraft($title: String!) {
    createProjectAnalysisReportDraft(title: $title) {
      id
      title
      status
    }
  }
`;

export const MUTATION_UPLOAD_PROJECT_ANALYSIS_REPORT_HTML = gql`
  mutation UploadProjectAnalysisReportHtml($report_id: String!, $file: Upload!) {
    uploadProjectAnalysisReportHtml(report_id: $report_id, file: $file) {
      id
      gcs_object_path
      original_filename
      mime_type
    }
  }
`;

export const MUTATION_SET_PROJECT_ANALYSIS_REPORT_RECIPIENTS = gql`
  mutation SetProjectAnalysisReportRecipients($report_id: String!, $user_ids: [String!]!) {
    setProjectAnalysisReportRecipients(report_id: $report_id, user_ids: $user_ids) {
      id
      recipient_count
    }
  }
`;

export const MUTATION_PUBLISH_PROJECT_ANALYSIS_REPORT = gql`
  mutation PublishProjectAnalysisReport($report_id: String!) {
    publishProjectAnalysisReport(report_id: $report_id) {
      id
      status
      published_at
    }
  }
`;

export const MUTATION_ARCHIVE_PROJECT_ANALYSIS_REPORT = gql`
  mutation ArchiveProjectAnalysisReport($report_id: String!) {
    archiveProjectAnalysisReport(report_id: $report_id) {
      id
      status
    }
  }
`;

export const MUTATION_DELETE_PROJECT_ANALYSIS_REPORT = gql`
  mutation DeleteProjectAnalysisReport($report_id: String!) {
    deleteProjectAnalysisReport(report_id: $report_id)
  }
`;
